






















































import Vue from 'vue';
import PSelect from '../p-select/p-select.vue';

export default Vue.extend({
  name: 'PSelectMultiple',
  props: {
    value: { type: Array, default: () => [] },
    items: { type: Array, default: () => [] },
    maxCharPerPill: { type: Number, default: 30 },
    placeholder: { type: String, default: undefined },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    canSearch: { default: false, type: Boolean },
  },
  data: () => ({
    selectedItems: {} as Record<string, any>,
    isOverflown: false,
    isOpen: false,
    selectedKeysOnOpen: [] as string[],
    hidePills: false,
    search: undefined,
  }),
  computed: {
    innerPlaceholder(): string | undefined {
      if (this.placeholder) return this.placeholder;
      if (this.$attrs.solo !== undefined) return this.$attrs.label;
      return undefined;
    },
    select(): InstanceType<typeof PSelect> {
      return this.$refs.select as InstanceType<typeof PSelect>;
    },
    numberSelected(): number {
      return Object.keys(this.selectedItems).length;
    },
    hasSelection(): boolean {
      return this.numberSelected > 0;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        if (this._.isArray(this.value) && this._.isArray(this.items)) {
          this.$nextTick(() => {
            const selected = this.value
              .map((id) => this.items.find((item: any) => id === this.select.getItemValue(item)))
              .filter((item) => !!item);
            this.$set(this, 'selectedItems', {});
            selected.forEach((item: any) => {
              this.$set(this.selectedItems, this.select.getItemValue(item), item);
            });
            this.checkForOverflow();
          });
        }
      },
    },
  },
  mounted() {
    this.checkForOverflow();
  },
  methods: {
    onResize() {
      this.checkForOverflow();
    },
    checkForOverflow() {
      if (!this.hasSelection) {
        this.isOverflown = false;
        return;
      }
      const pillsWrapper = this.$refs.pillsWrapper as HTMLElement;
      if (pillsWrapper) {
        this.isOverflown = pillsWrapper.scrollHeight > pillsWrapper.clientHeight || pillsWrapper.scrollWidth > pillsWrapper.clientWidth;
      } else {
        this.isOverflown = false;
      }
      if (this.isOverflown) {
        return;
      }
      this.$nextTick(() => {
        const pillsWrapper = this.$refs.pillsWrapper as HTMLElement;
        if (pillsWrapper) {
          this.isOverflown = pillsWrapper.scrollHeight > pillsWrapper.clientHeight || pillsWrapper.scrollWidth > pillsWrapper.clientWidth;
        } else {
          this.isOverflown = false;
        }
      });
    },
    onInput(item: any, id: number, display: string) {
      if (!this.selectedItems[id]) {
        this.addItem(item, false);
      } else {
        this.removeItem(item, false);
      }
    },
    clearItems() {
      Object.keys(this.selectedItems).forEach((key) => {
        this.$delete(this.selectedItems, key);
      });
      this.checkForOverflow();
      this.emitValues();
    },
    addItem(item: any, emit = true) {
      const id = this.select.getItemValue(item);
      this.$set(this.selectedItems, id, item);
      if (emit) this.emitValues();
      this.checkForOverflow();
    },
    removeItem(item: any, emit = true) {
      const id = this.select.getItemValue(item);
      this.$delete(this.selectedItems, id);
      if (emit) this.emitValues();
      this.checkForOverflow();
    },
    emitValues() {
      const selectedItems = Object.values(this.selectedItems);
      this.$emit('input', selectedItems.map((i) => this.select.getItemValue(i)));
      this.$emit('selection', selectedItems);
      this.checkForOverflow();
    },
    updateSelectedItems(isOpen:boolean) {
      const selectedKeys = Object.keys(this.selectedItems);

      if (!isOpen && this.isOpen !== isOpen && !(this.selectedKeysOnOpen.every((item) => selectedKeys.includes(item)) && selectedKeys.every((item) => this.selectedKeysOnOpen.includes(item)))) {
        const selectedItems = Object.values(this.selectedItems);
        this.$emit('input', selectedItems.map((i) => this.select.getItemValue(i)));
      }
      this.selectedKeysOnOpen = Object.keys(this.selectedItems);
      this.isOpen = isOpen;
      this.search = undefined;
      Vue.set(this, 'search', undefined);
      this.emitValues();
    },
  },
});
